var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import 'intersection-observer';
import { ThemedMedia } from './Media';
export var getSourceFromRatio = function (images) {
    if (typeof window === 'undefined') {
        return images.x1;
    }
    var cappedRatio = Math.min(3, Math.max(1, Math.ceil(window.devicePixelRatio)));
    return images["x" + cappedRatio] || images.x1;
};
export var defaultPreloadImage = function (src) {
    return new Promise(function (resolve, reject) {
        var img = document.createElement('img');
        img.onload = function () {
            resolve(src);
        };
        img.onerror = function (err) {
            reject(err);
        };
        img.src = src;
    });
};
var LazyImage = /** @class */ (function (_super) {
    __extends(LazyImage, _super);
    function LazyImage(props) {
        var _this = _super.call(this, props) || this;
        _this.unmounted = false;
        _this.preloadId = null;
        _this.intersectionObserver = null;
        _this.innerElement = null;
        _this.state = { loaded: false, image: '', intersected: false };
        _this.setInnerRef = _this.setInnerRef.bind(_this);
        return _this;
    }
    LazyImage.prototype.loadImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var src, currentPreloadId, preloadImage, preloadedSrc, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        src = getSourceFromRatio(this.props);
                        currentPreloadId = Symbol("LazyImage " + src + " preload-id");
                        this.preloadId = currentPreloadId;
                        preloadImage = this.props.preloadImage;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, preloadImage(src)];
                    case 2:
                        preloadedSrc = _a.sent();
                        if (this.preloadId === currentPreloadId) {
                            this.setState({ loaded: true, image: preloadedSrc });
                            this.preloadId = null;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        // tslint:disable-next-line no-console
                        console.warn(err_1.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LazyImage.prototype.componentDidUpdate = function (prevProps) {
        // If the image changed, load the new one
        if ((this.props.x1 !== prevProps.x1 ||
            this.props.x2 !== prevProps.x2 ||
            this.props.x3 !== prevProps.x3) &&
            this.innerElement) {
            this.startIntersectionObserver();
        }
    };
    LazyImage.prototype.componentWillUnmount = function () {
        this.unmounted = true;
        if (!this.state.intersected && this.intersectionObserver) {
            this.intersectionObserver.unobserve(this.innerElement);
        }
        if (this.preloadId) {
            this.preloadId = null;
        }
    };
    LazyImage.prototype.setInnerRef = function (element) {
        if (!element) {
            return;
        }
        this.innerElement = element;
        if ('innerRef' in this.props) {
            if (typeof this.props.innerRef === 'function') {
                this.props.innerRef(element);
            }
            else {
                this.props.innerRef.current = element;
            }
        }
        this.startIntersectionObserver();
    };
    LazyImage.prototype.startIntersectionObserver = function () {
        var _this = this;
        if (!this.intersectionObserver) {
            this.intersectionObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if ((entry.isIntersecting || entry.intersectionRatio > 0) &&
                        !_this.unmounted) {
                        _this.setState({ intersected: true });
                        _this.loadImage();
                        _this.intersectionObserver.unobserve(_this.innerElement);
                    }
                });
            });
        }
        this.setState({ intersected: false, loaded: false, image: '' });
        this.intersectionObserver.observe(this.innerElement);
        this.preloadId = null;
    };
    LazyImage.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return (this.props !== nextProps ||
            nextProps.children ||
            this.state.image !== nextState.image);
    };
    LazyImage.prototype.render = function () {
        var _a = this.props, x1 = _a.x1, x2 = _a.x2, x3 = _a.x3, preloadImage = _a.preloadImage, children = _a.children, thumbnail = _a.thumbnail, imgProps = __rest(_a, ["x1", "x2", "x3", "preloadImage", "children", "thumbnail"]);
        var _b = this.state, loaded = _b.loaded, image = _b.image, intersected = _b.intersected;
        return children ? (children({
            loaded: loaded,
            image: image,
            intersected: intersected,
            thumbnail: thumbnail,
            innerRef: this.setInnerRef,
        })) : (React.createElement("img", __assign({ ref: this.setInnerRef, src: intersected && loaded ? image : thumbnail }, imgProps)));
    };
    LazyImage.defaultProps = {
        preloadImage: defaultPreloadImage,
    };
    return LazyImage;
}(React.Component));
export { LazyImage };
export var ResponsiveLazyImage = function (props) {
    var x1 = props.x1, x2 = props.x2, x3 = props.x3, mobile = props.mobile, tablet = props.tablet, desktop = props.desktop, large_desktop = props.large_desktop, preloadImage = props.preloadImage, restProps = __rest(props, ["x1", "x2", "x3", "mobile", "tablet", "desktop", "large_desktop", "preloadImage"]);
    if (x1 && x2 && x3) {
        // Support for old responsive image format
        // that was working only for dpr
        return (React.createElement(LazyImage, __assign({ x1: x1, x2: x2, x3: x3, preloadImage: preloadImage }, restProps)));
    }
    else if (mobile && tablet && desktop) {
        // New responsive image format that supports
        // both dpr and main breakpoints
        return (React.createElement(ThemedMedia, null, function (matches) {
            var imageProps = matches.large_desktop && large_desktop
                ? large_desktop
                : matches.desktop
                    ? desktop
                    : matches.tablet
                        ? tablet
                        : mobile;
            return (React.createElement(LazyImage, __assign({ preloadImage: preloadImage }, imageProps, restProps)));
        }));
    }
    else {
        // tslint:disable-next-line no-console
        console.warn('<ResponsiveLazyImage /> is missing required props');
        return null;
    }
};
export var ResponsiveLazyImageMemo = React.memo(ResponsiveLazyImage);
